module.exports = __webpack_public_path__ + "static/media/ll-image-loader-anim.fe44ffb4.gif";